import { axiosProperty, throwResponse } from "config/axios";
import {
  IDashboardGraph,
  IDashboardParams,
  IDashboardTitle,
} from "../../interface";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

export const useGetPropertyDashboardNewsCountMostReader = (
  params?: IDashboardParams
): UseQueryResult<IDashboardTitle[], Error> => {
  return useQuery(
    ["dashboard-property-news", "count-most-reader", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/news-announcement/count-most-reader",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardNewsCountPerMonth = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-news", "count-reader-per-month", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/news-announcement/count-reader-per-month",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
